"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireConditionContext = void 0;
var QuestionnaireConditionContext;
(function (QuestionnaireConditionContext) {
    QuestionnaireConditionContext["Taxonomy"] = "TaxonomyConditionContext";
    QuestionnaireConditionContext["Answer"] = "AnswerConditionContext";
    QuestionnaireConditionContext["Concept"] = "ConceptConditionContext";
    QuestionnaireConditionContext["Quota"] = "QuotaConditionContext";
    QuestionnaireConditionContext["Variable"] = "VariableConditionContext";
})(QuestionnaireConditionContext || (exports.QuestionnaireConditionContext = QuestionnaireConditionContext = {}));
